<template>
  <div class="paper-bottom-download" v-if="!isPopWithDialog">
    <div class="paper-download-btn btn" data-io-click="tracker"  @click="handleDownload">
      <span class="download-paper-btn-text">免费下载</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "PaperDownloadButton",
  props: {
    isPopWithDialog: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleDownload() {
      this.$emit("download");
    },
  },
};
</script>

<style lang="scss" scoped>
.paper-bottom-download {
  position: absolute;
  bottom: 0;
  height: 66px;
  padding: 12px 20px;
  box-shadow: 0px -3px 10px 0px rgba(0, 0, 0, 0.05);
  background: #fff;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  .paper-download-btn {
    width: 162px;
    height: 42px;
    border-radius: 8px;
    background: #0057ff;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    cursor: pointer;

    &:hover {
      opacity: 0.8;
    }
  }
}
</style>
